
import axios from 'axios';
import { newAbortSignal } from '../../../utils';
import { SessionStore } from '../../../types/store/SessionStore';
import { Complaint, ComplaintRequest } from '../../../types/model/stage';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/project`;

export const saveComplaint = async (projectId:number, activityId: number, procedureId: number, stageId: number, complaintData: ComplaintRequest): Promise<Complaint> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = BASE_URL + '/' + projectId + '/activity/' + activityId + '/procedure/' + procedureId + '/stage/' + stageId + '/complaint';

  return await axios
    .post<Complaint>(finalURL, complaintData, {
      headers: {
        'content-type': 'application/json',
        'x-access-token': session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(
              parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            )
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
